const MS_IN_SECOND = 1000
const SECONDS_IN_HOUR = 3600

/** Milliseconds → whole seconds. Sub-second positive durations round up to 1s (nextjs parity). */
export const convertMillisecondsToSeconds = (ms: number): number => {
    if (ms > 0 && ms < MS_IN_SECOND) {
        return 1
    }

    return Math.floor(ms / MS_IN_SECOND)
}

/** Seconds → `mm:ss` (or `hh:mm:ss` past an hour). Invalid/negative input renders as `00:00`. */
export const convertSecondsToTime = (seconds: number): string => {
    if (!Number.isFinite(seconds) || seconds < 0) {
        return '00:00'
    }

    const iso = new Date(seconds * MS_IN_SECOND).toISOString()

    return seconds < SECONDS_IN_HOUR ? iso.substring(14, 19) : iso.substring(11, 19)
}

/**
 * Unix seconds → `21 Jun 2022`. The month is always the en-US short name and the order is fixed, as in
 * audio-web: `toLocaleDateString` would print `Jun 21, 2022` and would also change with the browser's
 * locale, so the same audio would read differently for two visitors.
 *
 * UTC, not the visitor's zone: the reference renders this on the server, so every visitor reads the
 * same day, and the SSR template can produce the same string.
 */
export const formatUploadDate = (seconds: number): string => {
    const date = new Date(seconds * MS_IN_SECOND)
    const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' })

    return `${date.getUTCDate()} ${month} ${date.getUTCFullYear()}`
}
